import API from "../../../global/api";

//GET CALLS

//ALL FORM DATA
export const requestCourtFormData = (data) => {
  return {
    type: "REQUEST_COURT_FORM_DATA",
  };
};
export const successCourtFormData = (data) => {
  return {
    type: "SUCCESS_COURT_FORM_DATA",
    payload: data,
  };
};
export const errorCourtFormData = () => {
  return {
    type: "ERROR_COURT_FORM_DATA"
  };
};

export const getCourtFormData = (data1) => {
  return (dispatch) => {
    dispatch(requestCourtFormData());
    API.post(`/serving_court_form/get-all-data`,data1).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successCourtFormData(data));
    }).catch(err => {
      dispatch(errorCourtFormData());
    })
  };
};



export const requestFormsPetitionPacket = (data) => {
  return {
    type: "REQUEST_FORMS_PETITION_PACKET",
  };
};
export const successFormsPetitionPacket = (data) => {
  return {
    type: "SUCCESS_FORMS_PETITION_PACKET",
    payload: data,
  };
};
export const errorFormsPetitionPacket = () => {
  return {
    type: "ERROR_FORMS_PETITION_PACKET",
  };
};

export const getFormsPetitionPacket = () => {
  return (dispatch) => {
    API.get(`/serving_court_form/get-form-petition-packet`, {
      headers: {
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successFormsPetitionPacket(data));
    }).catch((err)=>{
      dispatch(errorFormsPetitionPacket())
    })
  };
};

export const requestFormsServedSpouse = (data) => {
  return {
    type: "REQUEST_FORMS_SERVED_SPOUSE",
  };
};
export const successFormsServedSpouse = (data) => {
  return {
    type: "SUCCESS_FORMS_SERVED_SPOUSE",
    payload: data,
  };
};
export const errorFormsServedSpouse = (data) => {
  return {
    type: "ERROR_FORMS_SERVED_SPOUSE",
    payload: data,
  };
};

export const getFormsServedSpouse = () => {
  return (dispatch) => {
    API.get(`/serving_court_form/get-documents_serve_spouse`, {
      headers: {
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successFormsServedSpouse(data));
    });
  };
};

//FORMS

export const putDocumentsServed = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-documents-served-spouse`, data).then(
      (res) => {
        dispatch(successDocumentsServed(data));
      }
    );
  };
};

//Action Creator

export const requestDocumentsServed = (data) => {
  return {
    type: "REQUEST_DOCUMENTS_SERVED_SPOUSE",
  };
};
export const successDocumentsServed = (data) => {
  return {
    type: "SUCCESS_DOCUMENTS_SERVED_SPOUSE",
    payload: data,
  };
};
export const errorDocumentsServed = (data) => {
  return {
    type: "ERROR_DOCUMENTS_SERVED_SPOUSE",
    payload: data,
  };
};

//How Petition Packet Served

//API CALL

export const putHowPetitionPacketServed = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-spouse-served-petition`, data).then(
      (res) => {
        dispatch(successHowPetitionPacketServed(data));
      }
    );
  };
};

//Action Creator

export const requestHowPetitionPacketServed = (data) => {
  return {
    type: "REQUEST_HOW_PETITION_PACKET_SERVED",
  };
};
export const successHowPetitionPacketServed = (data) => {
  return {
    type: "SUCCESS_HOW_PETITION_PACKET_SERVED",
    payload: data,
  };
};
export const errorHowPetitionPacketServed = (data) => {
  return {
    type: "ERROR_HOW_PETITION_PACKET_SERVED",
    payload: data,
  };
};

//REGISTERED CALIFORNIA

//API CALL

export const putRegisteredCaliforniaServer = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-registered-california`, data).then(
      (res) => {
        dispatch(successRegisteredCaliforniaServer(data));
      }
    );
  };
};

//Action Creator

export const requestRegisteredCaliforniaServer = (data) => {
  return {
    type: "REQUEST_REGISTERED_CALIFORNIA_SERVER",
  };
};
export const successRegisteredCaliforniaServer = (data) => {
  return {
    type: "SUCCESS_REGISTERED_CALIFORNIA_SERVER",
    payload: data,
  };
};
export const errorRegisteredCaliforniaServer = (data) => {
  return {
    type: "ERROR_REGISTERED_CALIFORNIA_SERVER",
    payload: data,
  };
};

//DOCUMENTS MAILED CITY STATE

//API CALL

export const putDocumentsMailedCityState = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-server-mail-document-city`, data).then(
      (res) => {
        dispatch(successDocumentsMailedCityState(data));
      }
    );
  };
};

//Action Creator

export const requestDocumentsMailedCityState = (data) => {
  return {
    type: "REQUEST_DOCUMENTS_MAILED_CITY_STATE",
  };
};
export const successDocumentsMailedCityState = (data) => {
  return {
    type: "SUCCESS_DOCUMENTS_MAILED_CITY_STATE",
    payload: data,
  };
};
export const errorDocumentsMailedCityState = (data) => {
  return {
    type: "ERROR_DOCUMENTS_MAILED_CITY_STATE",
    payload: data,
  };
};

//DATE DOCUMENTS MAILED

//API CALL

export const putDateDocumentsMailed = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-server-mail-document-date`, data).then(
      (res) => {
        dispatch(successDateDocumentsMailed(data));
      }
    );
  };
};

//Action Creator

export const requestDateDocumentsMailed = (data) => {
  return {
    type: "REQUEST_DATE_DOCUMENTS_MAILED",
  };
};
export const successDateDocumentsMailed = (data) => {
  return {
    type: "SUCCESS_DATE_DOCUMENTS_MAILED",
    payload: data,
  };
};
export const errorDateDocumentsMailed = (data) => {
  return {
    type: "ERROR_DATE_DOCUMENTS_MAILED",
    payload: data,
  };
};

//DOCUMENTS MAILED ADDRESS

//API CALL

export const putDocumentsMailedAddress = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-server-mail-document-address`, data).then(
      (res) => {
        dispatch(successDocumentsMailedAddress(data));
      }
    );
  };
};

//Action Creator

export const requestDocumentsMailedAddress = (data) => {
  return {
    type: "REQUEST_DOCUMENTS_MAILED_ADDRESS",
  };
};
export const successDocumentsMailedAddress = (data) => {
  return {
    type: "SUCCESS_DOCUMENTS_MAILED_ADDRESS",
    payload: data,
  };
};
export const errorDocumentsMailedAddress = (data) => {
  return {
    type: "ERROR_DOCUMENTS_MAILED_ADDRESS",
    payload: data,
  };
};

//Server Address

//API CALL

export const putServerAddress = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-server-address`, data).then((res) => {
      dispatch(successServerAddress(data));
    });
  };
};

//Action Creator

export const requestServerAddress = (data) => {
  return {
    type: "REQUEST_SERVER_ADDRESS",
  };
};
export const successServerAddress = (data) => {
  return {
    type: "SUCCESS_SERVER_ADDRESS",
    payload: data,
  };
};
export const errorServerAddress = (data) => {
  return {
    type: "ERROR_SERVER_ADDRESS",
    payload: data,
  };
};

//SERVER NAME

//API CALL

export const putServerName = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-server-name`, data).then((res) => {
      dispatch(successServerName(data));
    });
  };
};

//Action Creator

export const requestServerName = (data) => {
  return {
    type: "REQUEST_SERVER_NAME",
  };
};
export const successServerName = (data) => {
  return {
    type: "SUCCESS_SERVER_NAME",
    payload: data,
  };
};
export const errorServerName = (data) => {
  return {
    type: "ERROR_SERVER_NAME",
    payload: data,
  };
};

//MAIL CARRIER

//API CALL

export const putMailCarrier = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-mail_carrier`, data).then((res) => {
      dispatch(successMailCarrier(data));
    });
  };
};

//Action Creator

export const requestMailCarrier = (data) => {
  return {
    type: "REQUEST_MAIL_CARRIER",
  };
};
export const successMailCarrier = (data) => {
  return {
    type: "SUCCESS_MAIL_CARRIER",
    payload: data,
  };
};
export const errorMailCarrier = (data) => {
  return {
    type: "ERROR_MAIL_CARRIER",
    payload: data,
  };
};

//MAILED FROM POST OFFICE
//API CALL

export const putMailedFromPostOffice = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-served_mail`, data).then((res) => {
      dispatch(successMailedFromPostOffice(data));
    });
  };
};

//Action Creator

export const requestMailedFromPostOffice = (data) => {
  return {
    type: "REQUEST_MAILED_FROM_POST_OFFICE",
  };
};
export const successMailedFromPostOffice = (data) => {
  return {
    type: "SUCCESS_MAILED_FROM_POST_OFFICE",
    payload: data,
  };
};
export const errorMailedFromPostOffice = (data) => {
  return {
    type: "ERROR_MAILED_FROM_POST_OFFICE",
    payload: data,
  };
};

//SERVED RESPONSE PACKET BY MAIL
//API CALL

export const putResponsePacketByMail = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-served-response-packet`, data).then(
      (res) => {
        dispatch(successResponsePacketByMail(data));
      }
    );
  };
};

//Action Creator

export const requestResponsePacketByMail = (data) => {
  return {
    type: "REQUEST_RESPONSE_PACKET_BY_MAIL",
  };
};
export const successResponsePacketByMail = (data) => {
  return {
    type: "SUCCESS_RESPONSE_PACKET_BY_MAIL",
    payload: data,
  };
};
export const errorResponsePacketByMail = (data) => {
  return {
    type: "ERROR_RESPONSE_PACKET_BY_MAIL",
    payload: data,
  };
};

//CaliforniaSheriffMarshalConstable
//API CALL
export const putCaliforniaSheriffMarshalConstable = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-server-constable`, data).then((res) => {
      dispatch(successCaliforniaSheriffMarshalConstable(data));
    });
  };
};

//Action Creator

export const requestCaliforniaSheriffMarshalConstable = (data) => {
  return {
    type: "REQUEST_CALIFORNIA-SHERIFF_MARSHAL_CONSTABLE",
  };
};
export const successCaliforniaSheriffMarshalConstable = (data) => {
  return {
    type: "SUCCESS_CALIFORNIA-SHERIFF_MARSHAL_CONSTABLE",
    payload: data,
  };
};
export const errorCaliforniaSheriffMarshalConstable = (data) => {
  return {
    type: "ERROR_CALIFORNIA-SHERIFF_MARSHAL_CONSTABLE",
    payload: data,
  };
};

//PostOfPersonServedSpouse

//Action Creator

export const requestPostOfPersonServedSpouse = (data) => {
  return {
    type: "REQUEST_PERSON_SERVED",
  };
};
export const successPostOfPersonServedSpouse = (data) => {
  return {
    type: "SUCCESS_PERSON_SERVED",
    payload: data,
  };
};
export const errorPostOfPersonServedSpouse = (data) => {
  return {
    type: "ERROR_PERSON_SERVED",
    payload: data,
  };
};

//API CALL

export const putPostOfPersonServedSpouse = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-person-served-spouse`, data).then(
      (res) => {
        dispatch(successPostOfPersonServedSpouse(data));
      }
    );
  };
};
//Person Served the Spouse

//Action Creator

export const requestPutServerDetails = (data) => {
  return {
    type: "REQUEST_SERVER_DETAILS",
  };
};
export const successPutServerDetails = (data) => {
  return {
    type: "SUCCESS_SERVER_DETAILS",
    payload: data,
  };
};
export const errorPutServerDetails = (data) => {
  return {
    type: "ERROR_SERVER_DETAILS",
    payload: data,
  };
};

//API CALL

export const putServerDetails = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-spouse-server-detail`, data).then((res) => {
      dispatch(successPutServerDetails(data));
    });
  };
};

//IncludingForms

//ACTION CREATORS

export const requestPutIncludingForms = () => {
  return {
    type: "REQUEST_INCLUDING_FORMS",
  };
};
export const successPutIncludingForms = (data) => {
  return {
    type: "SUCCESS_INCLUDING_FORMS",
    payload: data,
  };
};
export const errorPutIncludingForms = () => {
  return {
    type: "ERROR_INCLUDING_FORMS",
  };
};

//API CALL

export const putIncludingForms = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-form-petition-packet`, data).then(
      (res) => {
        dispatch(successPutIncludingForms(data));
      }
    );
  };
};

//ServedPetitionPacket

//ACTION CREATOR

export const requestPutServedPetitionPacket = (data) => {
  return {
    type: "REQUEST_SERVED_PETITION_PACKET",
  };
};
export const successPutServedPetitionPacket = (data) => {
  return {
    type: "SUCCESS_SERVED_PETITION_PACKET",
    payload: data,
  };
};
export const errorPutServedPetitionPacket = (data) => {
  return {
    type: "ERROR_SERVED_PETITION_PACKET",
    payload: data,
  };
};

//API CALL

export const putServedPetitionPacket = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-petition_served_packet`, data).then(
      (res) => {
        dispatch(successPutServedPetitionPacket(data));
      }
    );
  };
};

//Case Number

//ACTION CREATOR

export const requestPutCaseNumber = (data) => {
  return {
    type: "REQUEST_CASE_NUMBER",
  };
};
export const successPutCaseNumber = (data) => {
  return {
    type: "SUCCESS_CASE_NUMBER",
    payload: data,
  };
};
export const errorPutCaseNumber = (data) => {
  return {
    type: "ERROR_CASE_NUMBER",
    payload: data,
  };
};

//API CALL

export const putCaseNumber = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-case_number`, data).then((res) => {
      dispatch(successPutCaseNumber(data));
    });
  };
};

//FilledPetitionPacket

//API CALL

export const putFilledPetitionPacket = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-filed_petiton`, data).then((res) => {
      dispatch(successFilledPetitionPacket(data));
    });
  };
};

export const requestFilledPetitionPacket = (data) => {
  return {
    type: "REQUEST_FILLED_PETITION_PACKET",
  };
};
export const successFilledPetitionPacket = (data) => {
  return {
    type: "SUCCESS_FILLED_PETITION_PACKET",
    payload: data,
  };
};
export const errorFilledPetitionPacket = (data) => {
  return {
    type: "ERROR_FILLED_PETITION_PACKET",
    payload: data,
  };
};

// isPetitioner

export const requestPutPetitioner = (data) => {
  return {
    type: "REQUEST_PUT_PETITIONER",
  };
};
export const successPutPetitioner = (data) => {
  return {
    type: "SUCCESS_PUT_PETITIONER",
    payload: data,
  };
};
export const errorPutPetitioner = (data) => {
  return {
    type: "ERROR_PUT_PETITIONER",
    payload: data,
  };
};

//API CALL

export const PutPetitioner = (data) => {
  return (dispatch) => {
    API.put(`/serving_court_form/put-petitoner`, data).then((res) => {
      dispatch(successPutPetitioner(data));
    });
  };
};

//ACTION CREATORS START SERVING COURT

export const requestStartServingCourt = (data) => {
  return {
    type: "REQUEST_START_SERVING_COURT",
  };
};
export const successStartServingCourt = (data) => {
  return {
    type: "SUCCESS_START_SERVING_COURT",
    payload: data,
  };
};
export const errorStartServingCourt = (data) => {
  return {
    type: "ERROR_START_SERVING_COURT",
    payload: data,
  };
};

export const startCourtServing = (data) => {
  return (dispatch) => {
    API.post(`/serving_court_form/start-serving_court_form`,data).then(
      (res) => {
        let data = res.data;
        window.localStorage.setItem("servingCourtId",`${data.serving_court_form_Id}`
        );
        dispatch(successStartServingCourt(data));
      }
    );
  };
};
